import React, { useState, useEffect, useRef } from 'react';
import { ErrorMessage } from 'formik'

import moment from 'moment'
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import NumberFormat from 'react-number-format';
import { startCase, toLower, get, mapValues, has, isObject } from "lodash";
import { Form, Radio, Checkbox, Input, Label, Dropdown, TextArea, Button, Icon } from 'semantic-ui-react';
import { checkValidDateFormats, getDateInYYYYMMDD, setYear } from './dateUtils'
import userACL from '../store/access';
// import MockDate from 'mockdate'

export const FormikInputComponent = ({
  validateInput, placeholder, width, isLabel, label, isTxn, focus, disabled, required, style,
  noLabel,icontoShow,iconPosition,className,myChangeFunction,arrIndex,iserror,customErrorMsg,maxLength,
  compute,userProps,inputtype,mykeyUpFunction,mykeyDownFunction,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, submitCount, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) =>  {
  const handlecustomchange = (e,values) =>{
    handleChange(e)
    // handleBlur(e)
    myChangeFunction(e, values)
  }
  const handlekeyup = (e,values)=>{
    if(mykeyUpFunction)
      mykeyUpFunction(e);
  }
  const handlekeydown = (e,values)=>{
    if(mykeyDownFunction)
      mykeyDownFunction(e);
  }
  return(
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field className={className} required={required ? required : false} width={width ? width : null}  error={get(errors,field.name)}>{/* && get(touched,field.name) */}
        {
          noLabel && noLabel=="y" ? "" :
          (errors[field.name] && touched[field.name] && !isTxn ?
          <label>{errors[field.name]}</label> :
          <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>)
        }
        <Input name={field.name}
          type = {inputtype ? inputtype : "text"}
          onChange={handlecustomchange}
          value={userProps ?  userProps.value : (field.value == null ? "" : field.value)}
          disabled = {disabled}
          style = {style}
          // transparent = {disabled}
          placeholder={placeholder}
          autoFocus={focus ? focus : false}
          icon={icontoShow}
          iconPosition = {iconPosition}
          onBlur={(e) =>{
            if (compute) compute(values, setFieldValue)
          }}
          maxLength={maxLength}
          onKeyUp={handlekeyup}
          onKeyDown={handlekeydown}
        />
        {(errors[field.name] || iserror)  ? (<Label size="mini" color='red' basic pointing prompt>{iserror ? customErrorMsg : errors[field.name]}</Label>) : null}
        {/* <ErrorMessage name={errors[field.name]} render= { <Label size="mini" color='red' basic pointing prompt>{errors[field.name]}</Label> }/> */}
      </Form.Field>
);}


export const FormikTodosInputComponent = ({
  validateInput, placeholder, width, isLabel, label, isTxn, focus, disabled, required, style, myChangeFunction,arrIndex,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, handleBlur, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) =>  {

  const handleCustomChangeFunction = (e) =>{
    handleChange(e)
    // handleBlur(e)
    myChangeFunction(e, arrIndex)
  }

  return(
    <Form.Field required={required ? required : false} width={width ? width : null}  error={get(errors,field.name) && get(touched,field.name)}>
        {errors[field.name] && touched[field.name] && !isTxn ?
          <label>{errors[field.name]}</label> :
          <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
        <Input name={field.name}
          type="text"
          onChange={handleCustomChangeFunction}
          // onBlur={handleCustomChangeFunction}
          value={field.value}
          disabled = {disabled}
          style = {style}
          // transparent = {disabled}
          placeholder={placeholder}
          autoFocus={focus ? focus : false}
        />
        {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
      </Form.Field>
)};

/**
 * 
 * myChangeFunction and arrIndex are used when you have a field array and you need to do some changes to an index with your own function
 */
export const FormikDateComponent = ({
  isLabel, label, placeholder, width, focus, userProps, isTxn, isMandatory, setFieldValueM, getLabelClass, tabindex,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, setFieldValue, dirty }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {

const [dt, setDt] = useState(field.value ? moment(field.value).toDate() : null)
const manDate = userProps && userProps.setFieldManually !== undefined && userProps.setFieldManually !== "" ? userProps.setFieldManually : ""
let rawEvent = ''
const datePickerRef = React.useRef();
const handleDateChange = (e) => {
  if (rawEvent.type !== 'change'){
      setDt(e)
      const dt = moment(e)
      handleChange(dt.format("DD-MM-YYYY"))
      setFieldValue(field.name, dt.format("YYYY-MM-DD"))
      if(userProps.setFieldFunc){
        userProps.setFieldFunc(dt.format("DD-MM-YYYY"))
      }
  }
}
const handleclick = (e) => {
  datePickerRef.current.setFocus()
}

useEffect(() => {
  if(userProps && userProps.setFieldManually !== undefined && userProps.setFieldManually !== ""){
    setFieldValue(field.name, getDateInYYYYMMDD(userProps.setFieldManually))
    setDt(moment(getDateInYYYYMMDD(userProps.setFieldManually)).toDate()) 
  }
}, [manDate])

useEffect(() => {
  if(dt)
{
  const dt1 = moment(dt)
    handleChange(dt1.format("DD-MM-YYYY"))
      setFieldValue(field.name, dt1.format("YYYY-MM-DD"))
  }
}, [dt])

let manValue = setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined ? setFieldValueM : ""
  useEffect(() => {
    if(setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined && setFieldValueM !== ""){
      setFieldValue(field.name, setFieldValueM)
      setDt(moment(setFieldValueM).toDate()) 
    }else if(setFieldValueM && setFieldValueM === ""){
      setFieldValue(field.name, '')
      setDt('') 
    }
  }, [manValue])

const handleChangeRawEvent = (event) => {
  rawEvent = event
  const dt1 = checkValidDateFormats(event.target.value)
  if(dt1){
    handleChange(dt1)
    setFieldValue(field.name, getDateInYYYYMMDD(dt1))
    setDt(moment(getDateInYYYYMMDD(dt1)).toDate())
  }else{
    handleChange("")
    setFieldValue(field.name, "")
    setDt("")
  }
}

const handleBlurRawEvent = (event) => {
  const dt1 = checkValidDateFormats(event.target.value)
  if(dt1){
    const getValue = setYear(dt1.split("-")[0], dt1.split("-")[1], dt1.split("-")[2])
    handleChange(getValue)
    setFieldValue(field.name, getDateInYYYYMMDD(getValue))
    setDt(moment(getDateInYYYYMMDD(getValue)).toDate())
  }else{
    handleChange("")
    setFieldValue(field.name, "")
    setDt("")
  }
}
  
return (
  // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
      {errors[field.name] && touched[field.name] && !isTxn ?
      <label className={getLabelClass}>{errors[field.name]}</label> :
      <label className={getLabelClass}>{isLabel ? null : label ? label: startCase(toLower(field.name))}{isMandatory ? <font color="red"> * </font> : null}</label>}
      <div className='datePickerContainer' style={{position:"relative"}}>
      <DatePicker
        name={field.name}
        placeholderText={placeholder}
        dateFormat="dd-MM-yyyy"
        scrollableYearDropdown
        selected={field.value ? dt : null}
        onChange={handleDateChange}
        onChangeRaw={e=> handleChangeRawEvent(e)}
        autoComplete='off'
        autoFocus={focus ? focus : false}
        onBlur={(e) => handleBlurRawEvent(e)}
        tabIndex={tabindex ? tabindex : 0}
        ref={datePickerRef} 

      />
      <Icon
        className="customDatePickerIcon custom-input-DateIcon"
        name="calendar"
        onClick={(e)=>handleclick(e)}
      ></Icon>
      </div>
      {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
    </Form.Field>
)};

    
export const FormikAmountComponent = ({
  isLabel, label, saveOnBlur, decimal, compute, isTxn, path, placeholder, focus, width,
  field, // { name, value, onChange, onBlur }
  index,
  form: { touched, errors, values, handleSubmit, handleBlur, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
      {errors[field.name] && touched[field.name] && !isTxn ?
        <label>{errors[field.name]}</label> :
        <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
      <NumberFormat 
        thousandSeparator={true} 
        thousandsGroupStyle="lakh"
        decimalScale = {(decimal) ? decimal : 2 }
        placeholder={placeholder}
        name={field.name}
        value={field.value}
        onValueChange={(val) => setFieldValue(field.name, val.floatValue)}
        onBlur={(e) =>{
          // e.persist()
          // handleBlur(e)
          if (compute) compute(values, index, setFieldValue)
        }}
        autoFocus={focus ? focus : false}
      />
      {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
    </Form.Field>
  );
 
  export const FormikNumberComponent = ({
    isLabel, label, saveOnBlur, decimal, compute, isTxn, path, placeholder, focus, width, getLabelClass,
    field, // { name, value, onChange, onBlur }
    index,
    form: { touched, errors, values, handleSubmit, handleBlur, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    ...props
  }) => (
      // <Form.Field error={errors[field.name] && touched[field.name]}>
      <Form.Field width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
        {errors[field.name] && touched[field.name] && !isTxn ?
          <label className={getLabelClass}>{errors[field.name]}</label> :
          <label className={getLabelClass}>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
        <NumberFormat 
          thousandSeparator={false} 
          thousandsGroupStyle="lakh"
          decimalScale = {0}
          placeholder={placeholder}
          name={field.name}
          value={field.value}
          onValueChange={(val) => setFieldValue(field.name, val.floatValue)}
          onBlur={(e) =>{
            // e.persist()
            // handleBlur(e)
            if (compute) compute(values, index, setFieldValue)
          }}
          autoFocus={focus ? focus : false}
        />
        {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
      </Form.Field>
    );
  

  export const FormikRadioButtonComponent = ({
    userProps, focus, width, label, isTxn, isLabel, toggle, onChangeFunc,
    field, // { name, value, onChange, onBlur }
    form: { touched, errors, values,  handleChange, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    ...props
  }) => {

   
  
    return(
      // <Form.Field error={errors[field.name] && touched[field.name]}>
      <Form.Field width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
        {errors[field.name] && touched[field.name] && !isTxn ?
          <label>{errors[field.name]}</label> :
          <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
        <Radio
        toggle = {toggle ? toggle : null}
        name={field.name ? field.name : null}
        // id={userProps.id}
        value={userProps ? userProps.id : null}
        // checked={userProps.id === field.value}
        onChange={onChangeFunc ? (e, field) => onChangeFunc(e, field) : handleChange}
        autoFocus={focus ? focus : false}
      />
        <label>{userProps ? userProps.id : null}</label>
      </Form.Field>
    )};  
  
  
  export const FormikCheckBoxComponent = ({
    userProps, focus, width, label, isTxn, labelOnTop= false, isLabel, className,toggle, onChangeFunc, defaultChecked, disabled, checked, checkedFunc, 
    field,icontoShow,iconPosition,myChangeFunction,arrIndex,iserror,customErrorMsg, // { name, value, onChange, onBlur }
    form: { touched, errors, values,  handleChange, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    ...props
  }) => {
    const handlecustomchange = (e,values) =>{
      handleChange(e)
      // handleBlur(e)
      myChangeFunction(e, values)
    }
    return(
      // <Form.Field error={errors[field.name] && touched[field.name]}>
      <Form.Field width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
        {errors[field.name] && touched[field.name] && !isTxn ?
          <label>{errors[field.name]}</label> :
          <label>{labelOnTop ? label : null}</label>
        }
        <Checkbox
        className = {className}
        // defaultChecked = {defaultChecked ? defaultChecked : null}
        toggle = {toggle ? toggle : null}
        name={field.name ? field.name : null}
        label = {labelOnTop ? null: label}
        disabled = {disabled}
        value={userProps ? userProps.value : null}
        checked= {userProps? userProps.value == 1 : false}
        // onChange={onChangeFunc ? (e, {checked}) => onChangeFunc(e, {checked}) : handleChange}
        onChange={handlecustomchange}
        autoFocus={focus ? focus : false}
        icon={icontoShow}
        iconPosition = {iconPosition}
      />
      {(errors[field.name] || iserror)  ? (<Label size="mini" color='red' basic pointing prompt>{iserror ? customErrorMsg : errors[field.name]}</Label>) : null}
        {/* <label>{userProps ? userProps.id : null}</label> */}
      </Form.Field>
    )};  
  
  export const FormikSelectComponent = ({
    userProps, isLabel, label, isTxn, isSelection, focus, required, multiple, width, getLabelClass, tabindex, ref, sefFocusCalled,
    field,iserror,customErrorMsg, noLabel,style,className,// { name, value, onChange, onBlur }
    form: { touched, errors, values, handleChange, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    ...props
  }) => {

    // console.log(values)
  
    const setF = React.createRef()
    let [onchange,setonchange]  = useState(0);
    useEffect(() => {
      if(sefFocusCalled === true){
        if(setF.current){
          setF.current.handleFocus()
        }
      }
      if(userProps?.fixedit){
        setFieldValue(field.name, userProps.fixedit)
        if (userProps.getValue)
          userProps.getValue(userProps.fixedit, setFieldValue, values, userProps.options,field.name);
      }
    }, [])
    useEffect(() => {
      // console.log("user effect===="+userProps.fixedit,"=field="+field.value+"=onchange="+onchange)
      if(onchange == 0){
        setFieldValue(field.name, userProps.fixedit)
        if (userProps.getValue && userProps.fixedit)
          userProps.getValue(userProps.fixedit, setFieldValue, values, userProps.options,field.name);
      }else{
        setonchange(0)
      }
    }, [userProps.fixedit])
    
  const onChange = (value) => {
    setonchange(1)
    // console.log("onChange="+userProps.fixedit,"=value="+value+"=onchange="+onchange)
    setFieldValue(field.name, value)
    if (userProps.getValue)
      userProps.getValue(value, setFieldValue, values, userProps.options,field.name);
  }

  return (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field className={className} width={width ? width : null} required={required ? required : false} error={get(errors,field.name) && get(touched,field.name)}>
      {
        noLabel && noLabel=="y" ? "" :
        (
        errors[field.name] && touched[field.name] && !isTxn ?
        <label className={getLabelClass}>{errors[field.name]}</label> :
        <label className={getLabelClass}>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>
        )
      }
      {/* {console.log("userProps.fixedit=", userProps.fixedit,"=field.value=",field.value)} */}
      <Dropdown
        search
        selectOnBlur = {false}
        selection={isSelection ? isSelection : true}
        id={field.id}
        style = {style}
        multiple = {multiple ? multiple : false}
        name={field.name}
        trigger={userProps.trigger}
        className= {userProps.className}
        placeholder={userProps.placeholder}
        options={userProps.options}
        value={userProps ? userProps.fixedit ? userProps.fixedit : field.value : field.value}
        onChange={(e, { value }) => onChange(value)}
        autoFocus={focus ? focus : false}
        tabIndex={tabindex ? tabindex : 0}
        // clearable
        disabled={userProps ? userProps.isDisable ? userProps.isDisable : null : null}
        ref={setF}
        icon={userProps.icon}
        iconPosition={userProps.iconPosition}
        />   
        {(errors[field.name] || iserror)  ? (<Label size="mini" color='red' basic pointing prompt>{iserror ? customErrorMsg : errors[field.name]}</Label>) : null}  
      {/* {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null } */}
      </Form.Field>
  )};  
  
  
export const FormikAsyncSelectComponent = ({
  userProps, isLabel, label, isTxn, isSelection, focus, width, getLabelClass, tabindex, sefFocusCalled,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, setFieldValue, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {

  const onChange = (value) => {
    setFieldValue(field.name, value)
    if (userProps.getValue)
      userProps.getValue(value, values);
  }

  const [searchStr, setSearchStr] = useState('');
  const loadOptions = (searchQuery) => {
    userProps.getInputValue(searchQuery, values.id, values);
    setSearchStr(searchQuery)
  }


  const setF = React.createRef()
  useEffect(() => {
    if(sefFocusCalled === true){
      if(setF.current){
        setF.current.handleFocus()
      }
    }
  }, [])

  return (

    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
      {errors[field.name] && touched[field.name] && !isTxn ?
        <label className={getLabelClass}>{errors[field.name]}</label> :
        <label className={getLabelClass}>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
      <Dropdown
        search
        selection={isSelection ? true : false}
        // selectOnNavigation={true}
        id={field.id}
        name={field.name}
        placeholder={userProps.placeHolder}
        options={userProps.searchOptions && userProps.searchOptions.length > 0 ? userProps.searchOptions : userProps.options}
        value={field.value}
        onSearchChange={(e, { searchQuery }) => loadOptions(searchQuery)}
        onChange={(e, { value }) => onChange(value)}
        autoFocus={focus ? focus : false}
        noResultsMessage={searchStr.length > 3 ? 'No Data Found' :  'Please Type to search Data'}
        tabIndex={tabindex ? tabindex : 0}
        ref={setF}
        // clearable
        />
      {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
      </Form.Field>
  )
};  



export const FormikTextAreaComponent = ({
  userProps, isTxn, isLabel, label, placeholder, disabled,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, handleBlur, setFieldValue, HeaderClick }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {

  const [ count, setCount ] = useState(0)

  const onChange = (syntheticEvent, value) => {
    setFieldValue(field.name, value.value)
    setCount(value.value.length)
    if(value.value !== ""){
      if (userProps && userProps.getValue)
        userProps.getValue(value.value);
    }
    /* else{
      if (userProps.getValue)
        userProps.getValue('');
    } */
  }
  
  useEffect(() => {
    if(userProps && userProps.displayCount !== undefined && userProps.displayCount === true && field.value.length === 0)
      setCount(0)
  }, [field.value])

  const height = userProps ? (userProps.height === undefined ? 3 : (userProps.height === '' ? 3 : userProps.height === 0 ? 3 : userProps.height)): 3;
  const isFloatLeft = userProps && userProps.displayCount !== undefined && userProps.displayCount === true ? 'left' : null
  return (
    <Form.Field error={get(errors,field.name) && get(touched,field.name)}>
      {errors[field.name] && touched[field.name] && !isTxn ?
        <label style={{float: isFloatLeft}}>{errors[field.name]}</label> :
        <label style={{float: isFloatLeft}}>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
      {userProps ? userProps.displayCount !== undefined && userProps.displayCount === true ?
          <label style={{float: 'right'}}>{count} / {userProps.maxLength}</label>
          : null: null}
        <TextArea
          name={field.name}
          style={{ 
              resize: 'none', 
              width: '100%'
          }}
          value={field.value}
          onChange={onChange}
          disabled = {disabled}
          rows={height}
          maxLength={userProps ? userProps.maxLength : null}
          placeholder={placeholder}>
        </TextArea>
        {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
      </Form.Field>
  )
};



export const FormikPasswordComponent = ({
  validateInput, placeholder, width, isLabel, label, isTxn, focus,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) =>  (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
        {errors[field.name] && touched[field.name] && !isTxn ?
          <label>{errors[field.name]}</label> :
          <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
        <Input name={field.name}
          type="password"
          onChange={handleChange}
          value={field.value}
          placeholder={placeholder}
          autoFocus={focus ? focus : false}
        />
        {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
      </Form.Field>
);

export const FormikFileUploadComponent = ({
  validateInput, placeholder, width, isLabel, label, isTxn, focus,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values, handleChange, handleUpload, submitCount }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) =>  (
    // <Form.Field error={errors[field.name] && touched[field.name]}>
    <Form.Field width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
        {errors[field.name] && touched[field.name] && !isTxn ?
          <label>{errors[field.name]}</label> :
          <label>{isLabel ? null : label ? label: startCase(toLower(field.name))}</label>}
         <Form.Group widths={1}>
        <Input name={field.name}
          type="file"
          style={{width: "85.5%"}}
          onChange={handleChange}
          value={field.value}
          placeholder={placeholder}
          autoFocus={focus ? focus : false}
        />
         <Button type="button" onClick ={handleUpload} floated="right" color="grey" size="small" className="CustomeBTN"> Upload File </Button>
         </Form.Group>
        {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
      </Form.Field>
);


/**
 * 
 * myChangeFunction and arrIndex are used when you have a field array and you need to do some changes to an index with your own function
 */
// export const FormikInputDateComponent = ({
//   isLabel, label, placeholder, width, focus, userProps, isTxn, isMandatory, setFieldValueM, getLabelClass, tabindex, style,
//   field, // { name, value, onChange, onBlur }
//   form: { touched, errors, values, handleChange, setFieldValue, dirty }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
//   ...props
// }) => {

  // console.log(field.value)

// const [dt, setDt] = useState(field.value ? field.value : field.value)
// const manDate = userProps && userProps.setFieldManually !== undefined && userProps.setFieldManually !== "" ? userProps.setFieldManually : ""

// let rawEvent = ''
// // const handleDateChange = (e) => {
// //   if (rawEvent.type !== 'change'){
// //       setDt(e)
// //       const dt = moment(e)
// //       handleChange(dt.format("DD-MM-YYYY"))
// //       setFieldValue(field.name, dt.format("YYYY-MM-DD"))
// //   }
// // }

// useEffect(() => {
//   if(userProps && userProps.setFieldManually !== undefined && userProps.setFieldManually !== ""){
//     console.log(userProps.setFieldManually)
//     setFieldValue(field.name, getDateInYYYYMMDD(userProps.setFieldManually))
//     setDt(userProps.setFieldManually) 
//   }
//   console.log(manDate)
// }, [manDate])

// let manValue = setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined ? setFieldValueM : ""
//   useEffect(() => {
//     if(setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined && setFieldValueM !== ""){
//       setFieldValue(field.name, setFieldValueM)
//       setDt(setFieldValueM) 
//     }else if(setFieldValueM && setFieldValueM === ""){
//       setFieldValue(field.name, '')
//       setDt('') 
//     }
//     console.log(setFieldValueM, "line no 705")
//   }, [manValue])


// const handleBlurRawEvent = (event) => {
//   const dt1 = checkValidDateFormats(event.target.value)
//   console.log(dt1)
//   if(dt1){
//     const getValue = setYear(dt1.split("-")[0], dt1.split("-")[1], dt1.split("-")[2])
//     console.log(getValue)
//     handleChange(getValue)
//     setFieldValue(field.name, getValue)
//     setDt(getValue)
//   }else{
//     handleChange("")
//     setFieldValue(field.name, "")
//     setDt("")
//   }
// }
// const setDateOnChange = (date) => {  
//   console.log(date)
//   handleChange(moment(date).format("DD-MM-YYYY"))
//   setFieldValue(field.name, moment(date).format("DD-MM-YYYY"))
//   setDt(moment(date).format("DD-MM-YYYY"))
// }
// console.log(dt)
// const onChange = (value) => {  
//   console.log(value)
//   setDt(value)
// }

// const ExampleCustomInput = ({ value, onClick }) => {
//   const ref = React.createRef()
//   return(
//     <>
//       <Icon className="custom-input-DateIcon" name="calendar" onClick={onClick} ref={ref}></Icon>
//     </>
//   )
// };
// return (
//   // <Form.Field error={errors[field.name] && touched[field.name]}>
//     <Form.Field width={width ? width : null} error={get(errors,field.name) && get(touched,field.name)}>
//       {errors[field.name] && touched[field.name] && !isTxn ?
//       <label className={getLabelClass}>{errors[field.name]}</label> :
//       <label className={getLabelClass}>{isLabel ? null : label ? label: startCase(toLower(field.name))}{isMandatory ? <font color="red"> * </font> : null}</label>}
//       <>
//         <Input name={field.name}
//           type="text"
//           // onChange={handleChange}
//           value={dt}
//           style = {{width: "60%"}}
//           // transparent = {disabled}
//           placeholder={placeholder}
//           onChange={(e, { value }) => onChange(value)}
//           // onChange={handleDateChange}
//           onChangeRaw={e=> handleBlurRawEvent(e)}
//           autoComplete='off'
//           autoFocus={focus ? focus : false}
//           // onBlur={(e) => handleBlurRawEvent(e)}
//           tabIndex={tabindex ? tabindex : 0}
//         />  
//         <DatePicker
//             customInput={<ExampleCustomInput />}
//             dateFormat="dd-MM-yyyy"
//             onChange={(date) => setDateOnChange(date)}
//         />
//         {/* <DatePicker
//           name={field.name}
//           placeholderText={placeholder}
//           dateFormat="dd-MM-yyyy"
//           scrollableYearDropdown
//           selected={field.value ? dt : null}
//           onChange={handleDateChange}
//           onChangeRaw={e=> handleChangeRawEvent(e)}
//           autoComplete='off'
//           autoFocus={focus ? focus : false}
//           onBlur={(e) => handleBlurRawEvent(e)}
//           tabIndex={tabindex ? tabindex : 0}
//         /> */}
//       </>
//       {isTxn ? <ErrorMessage name={field.name} render= { msg => <Label size="mini" color='red' basic pointing prompt>{msg}</Label> }/>: null }
//     </Form.Field>
// )};



export const FormikInputDateComponent = ({ 
  isLabel,
  label,
  placeholder,
  width,
  focus,
  userProps,
  isTxn,
  isMandatory,
  setFieldValueM,
  getLabelClass,
  tabindex,
  style,
  noLabel,
  field,
  inputWidth,
  searchContent,
  from,
  form: { touched, errors, values, handleChange, setFieldValue, dirty },
  ...props
}) => {
  const [date, setDate] = useState(new Date());
  const [dt, setDt] = useState(field.value ? field.value : null);
   useEffect(() => {
      if (searchContent && searchContent[field.name] ) {
        setDate(new Date(searchContent[field.name].toString().split("-").reverse().join("-")))
      }
    }, [])

  const manDate =
    userProps &&
      userProps.setFieldManually !== undefined &&
      userProps.setFieldManually !== ""
      ? userProps.setFieldManually
      : "";
  let rawEvent = "";
  // const dispatch = useDispatch()
  useEffect(() => {
    if (
      userProps &&
      userProps.setFieldManually !== undefined &&
      userProps.setFieldManually !== ""
    ) {
      setFieldValue(field.name, userProps.setFieldManually);
      // dispatch(setSearchContent({ ...searchContent, [field.name]: userProps.setFieldManually }))
      setDt(userProps.setFieldManually);
    }
  }, [manDate]);
  let manValue =
    setFieldValueM && setFieldValueM !== null && setFieldValueM !== undefined
      ? setFieldValueM
      : "";
  useEffect(() => {
    if (
      setFieldValueM &&
      setFieldValueM !== null &&
      setFieldValueM !== undefined &&
      setFieldValueM !== ""
    ) {
      setFieldValue(field.name, setFieldValueM);
      setDt(setFieldValueM);
    } else if (setFieldValueM && setFieldValueM === "") {
      setFieldValue(field.name, "");
      setDt("");
    }
  }, [manValue]);
  const handleBlurRawEvent = (event) => {
    const dt1 = checkValidDateFormats(event.target.value);
    if (dt1) {
      const getValue = setYear(
        dt1.split("-")[0],
        dt1.split("-")[1],
        dt1.split("-")[2]
      );
      handleChange(getValue);
      setFieldValue(field.name, getValue);
      setDate(new Date(getValue.toString().split("-").reverse().join("-")))
      setDt(getValue);
      // if (props.setType && !props.fromPage) {
      //   props.setType({ ...props.type, [field.name]: getValue })
      // }
    } else {
      // console.log("props.type", "")
      handleChange("");
      setFieldValue(field.name, "");
      setDt("");
      // if (props.setType && !props.fromPage) {
      //   props.setType({ ...props.type, [field.name]: "" })
      // }
    }
  };
  const setDateOnChange = (date) => {
    handleChange(moment(date).format("DD-MM-YYYY"));
    setFieldValue(field.name, moment(date).format("DD-MM-YYYY"));
    setDate(new Date(moment(date).format("DD-MM-YYYY").toString().split("-").reverse().join("-")))

    setDt(moment(date).format("DD-MM-YYYY"));
  };
  const onChange = (value) => {
    setDt(value);
  };
  const ExampleCustomInput = ({ value, onClick }) => {
    const ref = React.createRef();
    return (
      <>
        <Icon
          className="custom-input-DateIcon"
          name="calendar"
          onClick={onClick}
          ref={ref}
        ></Icon>
      </>
    );
  };


  return (
    <Form.Field
      width={width ? width : null}
      error={get(errors, field.name) && get(touched, field.name)}
    >
      {errors[field.name] && touched[field.name] && !isTxn ? (
        <label className={getLabelClass}>{errors[field.name]}</label>
      ) : (
        <label className={getLabelClass}>
          {isLabel
            ? null
            : label
              ? label
              : noLabel
                ? null
                : startCase(toLower(field.name))}
          {isMandatory && !noLabel ? <font color="red"> * </font> : null}
        </label>
      )}
      <>
        <Input
          name={field.name}
          type="text"
          value={dt}
          style={{ width: `${inputWidth ? inputWidth : "60%"}` }}
          // transparent = {disabled}
          placeholder={placeholder}
          onChange={(e, { value }) => onChange(value)}
          autoComplete="off"
          autoFocus={focus ? focus : false}
          onBlur={(e) => handleBlurRawEvent(e)}
        />
        <DatePicker
          customInput={<ExampleCustomInput />}
          dateFormat="dd-MM-yyyy"
          selected={date}
          onChange={(date) => setDateOnChange(date)}
        />
      </>
      {isTxn ? (
        <ErrorMessage
          name={field.name}
          render={(msg) => (
            <Label size="mini" color="red" basic pointing prompt>
              {msg}
            </Label>
          )}
        />
      ) : null}
    </Form.Field>
  );
};


